import type { ComputedRef } from 'vue'
import type { DisciplineKanbanTab } from './enums'

import { useAdminRoutes } from '@shared/lib/routes'

import { getKanbanRouteName } from './discipline-general-info'

interface DisciplineKanbanSource {
  id: number
  stage: string | null
}

/**
 * The API dropped the kanban link; it is rebuilt the way `KanbanService::getDisciplineUrl` built it. The kanban opens
 * the card from the hash and, with `tab`, on that card tab, as the legacy pages did through the shared store.
 */
export const useDisciplineKanbanUrl = (
  source: () => DisciplineKanbanSource | null,
  tab?: DisciplineKanbanTab,
): ComputedRef<string | null> =>
  computed<string | null>(() => {
    const discipline = source()
    const routeName = getKanbanRouteName(discipline?.stage ?? null)
    if (!discipline || !routeName) return null

    const url = useAdminRoutes(routeName, { q: discipline.id, ...(tab && { tab }) })
    return url ? `${url}#${discipline.id}` : null
  })
